import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Gamepad2, X } from "lucide-react";

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.4-1.7 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.6C16.8 3.4 14.6 2.5 12 2.5 6.8 2.5 2.5 6.8 2.5 12S6.8 21.5 12 21.5c5.5 0 9.1-3.9 9.1-9.3 0-.6-.1-1.1-.2-1.6H12z"/></svg>
);

export const GoogleButton = ({ next, label = "Continua con Google", testid = "google-login-btn" }) => {
  const { googleLogin } = useAuth();
  return (
    <button type="button" onClick={() => googleLogin(next)} data-testid={testid}
      className="w-full flex items-center justify-center gap-3 bg-white text-black font-semibold rounded-md py-3 hover:bg-slate-100 transition-colors">
      <GoogleIcon /> {label}
    </button>
  );
};

export default function PlayButton() {
  const { user } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  if (pathname.startsWith("/paddock") || pathname.startsWith("/admin") || pathname.startsWith("/organizer")) return null;

  const go = () => { if (user) nav("/paddock"); else setOpen(true); };

  return (
    <>
      <button onClick={go} data-testid="play-fab"
        className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 rounded-full pl-5 pr-6 py-3.5 bg-[#FF1E27] text-white font-display font-black text-lg tracking-wider shadow-[0_0_40px_-5px_rgba(255,30,39,0.9)] hover:scale-105 transition-transform">
        <span className="absolute inset-0 rounded-full bg-[#FF1E27] animate-ping opacity-30 group-hover:opacity-0" />
        <Gamepad2 className="w-6 h-6 relative" />
        <span className="relative">PLAY</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="play-modal">
          <div className="rl-card rl-watermark p-8 w-full max-w-sm relative" onClick={e => e.stopPropagation()}>
            <button className="absolute top-3 right-3 text-slate-500 hover:text-white" onClick={() => setOpen(false)} data-testid="play-modal-close"><X className="w-5 h-5" /></button>
            <img src="/logo-wide.png" alt="Rally Love" className="h-10 mb-5" />
            <div className="pill-badge pill-amber mb-3">PLAY RALLY</div>
            <h2 className="font-display font-black text-2xl mb-1">Entra nel gioco</h2>
            <p className="text-sm text-slate-400 mb-6">Quiz, pronostici e missioni sponsor. Accedi in un tap e inizia a guadagnare punti.</p>
            <GoogleButton next="/paddock" />
            <div className="my-4 flex items-center gap-3 text-[10px] font-mono-rl text-slate-600 uppercase"><span className="flex-1 h-px bg-white/10" /> oppure <span className="flex-1 h-px bg-white/10" /></div>
            <div className="flex gap-2">
              <button className="btn-outline-rl flex-1 !py-2 text-sm" onClick={() => nav("/login?next=/paddock")} data-testid="play-modal-login">ACCEDI</button>
              <button className="btn-outline-rl flex-1 !py-2 text-sm" onClick={() => nav("/register?next=/paddock")} data-testid="play-modal-register">REGISTRATI</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
